export default __webpack_public_path__ + "static/acn_logo.026edd10.svg";